import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { Tarea, TareaTipo } from "../../../interfaces/tarea";
import { Validators, FormControl } from "@angular/forms";
import { TareaService } from "../../../providers/tarea.service";
import { Moment } from "moment";
import * as moment from 'moment';
import { WMatTimePickerComponent } from "../../../components/timer/time-control";
import { MatSelect } from "@angular/material";
import { ReplaySubject } from "rxjs";
import { Cotizacion } from "../../../interfaces/cotizacion";
import { CotizacionService } from "../../../providers/cotizacion.service";
import { TareaResponsable } from "../tarea-responsables/tarea-responsable/tarea-responsable";
import { TipoUsuario, Usuario } from "../../../interfaces/usuario";
import { UsuarioService } from "../../../providers/usuario.service";
import { Telefono } from "../../../components/telefono/telefono.component";

@Component({
  selector: 'app-tarea',
  templateUrl: './tarea.component.html',
  styleUrls: ['./tarea.component.scss']
})
export class TareaComponent implements OnInit {
  @Input() IdTarea?: number | string;
  tarea: Tarea;
  @Input() IdCotizacion?: number | string = null;
  @Input() buscarCotizacion?: number | string = null;

  cotizaciones: Cotizacion[] = <Cotizacion[]>[];
  cargandoCotizaciones: boolean = false;
  @Output() onTareaInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  notificacion: boolean = false;

  usuarios: Usuario[] = [];
  responsable: any[] = [];
  responsables : any[] = [];
  grupos : any[] = [];


  @ViewChild('horaTareaInput') horaTareaInput: WMatTimePickerComponent;
  @ViewChild('horaNotificacionInput') horaNotificacionInput: WMatTimePickerComponent;

  tituloFormControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(200)
  ]);
  fechaTareaFormControl = new FormControl('', [
    Validators.required
  ]);

  horaTareaFormControl = new FormControl('', [
    Validators.required
  ]);

  horaNotificacion = new FormControl('', [

  ]);

  responsablesFormControl = new FormControl('', [

  ]);

  // para el select con buscador 
  public cotizacionesFiltroCtrl: FormControl = new FormControl();
  public cotizacionesFiltradas: ReplaySubject<Cotizacion[]> = new ReplaySubject<Cotizacion[]>(1);
  @ViewChild('filtroCotizacion') filtroCotizacion: MatSelect;

  constructor(
    private tareaService: TareaService,
    private cotizacionService: CotizacionService,
    private usuarioService: UsuarioService

  ) { }

  ngOnInit() {
    this.tarea = new Tarea();

    if (this.IdTarea != null) { // si recibo un id solicitar los datos 
      this.formState.emit({ cargando: true });
      this.tareaService.getTareas(
        {
          page: null,
          pageSize: null
        },
        {
          sort: null,
          order: null
        },
        {
          IdTarea: this.IdTarea
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.tareas) {
            var tarea = respuesta.data.tareas[0];
            if (tarea) {
              //console.log(tarea, 'tada');
              console.log(tarea, "tarea");
              
              this.tarea = new Tarea(
                tarea.IdTarea,
                tarea.titulo,
                tarea.fechaTarea,
                tarea.fechaTarea ? moment(tarea.fechaTarea).format('HH:mm:ss') : null,
                tarea.fechaNotificacion,
                tarea.fechaNotificacion ? moment(tarea.fechaNotificacion).format('HH:mm:ss') : null,
                tarea.descripcion,
                tarea.cantidadResponsables,
                tarea.totalCompletadasResponsables,
                new Cotizacion(
                  tarea.cotizacion.IdCotizacion
                ),
                new TareaTipo(
                  tarea.tipo.id,
                  tarea.tipo.descripcion
                ),
                (tarea.soyResponsable) ? new TareaResponsable(
                  tarea.soyResponsable.IdTareaResponsable,
                  new Usuario(
                    tarea.soyResponsable.usuario.IdUsuario,
                    tarea.soyResponsable.usuario.usuario,
                    null,
                    null,
                    null,
                    tarea.soyResponsable.usuario.nombre,
                    tarea.soyResponsable.usuario.apellido
                  ),
                  tarea.soyResponsable.fechaCompletada
                ) : null
              );

              let responsables_tarea = tarea.responsables;

              this.responsables = [];
              responsables_tarea.forEach(element => {
                this.responsables.push(element.IdUsuario);
              });

              if (this.tarea.tipoTarea.IdTareaTipo != 1 && this.tarea.tipoTarea.descripcion) {
                this.tituloFormControl.disable();
                this.fechaTareaFormControl.disable();
              }

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }

    
    this.traerResposables();
    this.getGrupos();
  }

  /**
   * Función que sabe como filtrar las entidades
   */
  private filtrarCotizaciones() {
    if (!this.cotizaciones) {
      return;
    }

    // get the search keyword
    let search = this.cotizacionesFiltroCtrl.value;
    if (!search) {
      this.cotizacionesFiltradas.next(this.cotizaciones.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the banks
    this.cotizacionesFiltradas.next(
      this.cotizaciones.filter(cotizacion => {
        return ((cotizacion.numero + ' - ' + cotizacion.entidad.razonSocial).toLowerCase().indexOf(search) > -1);
      })
    );
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onTareaInput.emit();
  }

  fechaNotificacionFilter = (d: Moment): boolean => {
    // la fecha de notificación debe ser anterior a la fecha de la tarea
    return d.isSameOrBefore(this.fechaTareaFormControl.value);
  }

  clearFechaNotificacion(): void {
    this.tarea.fechaNotificacion = null;
    this.horaNotificacionInput.clearTime();
  }

  compararCotizacion(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdCotizacion == tipo2.IdCotizacion;
    }

    return false;
  }

  onClearCotizacion(event: any = null): void { // limpiar seleccionado
    if (event) {
      event.stopPropagation(); // porque si no se abre el select
    }

    this.tarea.cotizacion = new Cotizacion(); // modificar modelo
  }

  traerCotizaciones(): void {
    this.cotizaciones = [];
    this.cargandoCotizaciones = true;
    this.cotizacionService.getCotizaciones(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: ''
      }
    ).subscribe( // suscribimos una nueva busqueda
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.cotizaciones) {
          respuesta.data.cotizaciones.forEach((cotizacion) => {
            this.cotizaciones.push(<Cotizacion>{
              IdCotizacion: cotizacion.IdCotizacion,
              entidad: cotizacion.entidad,
              numero: cotizacion.numero
            });
          });

          // actualizar filtros 
          this.filtrarCotizaciones();
        }
      },
      error => {
        this.cargandoCotizaciones = false;
      },
      () => {
        this.cargandoCotizaciones = false;
      }
    );
  }

  getTarea(): Tarea {
    // revisar las validaciones
    if (this.tituloFormControl.hasError('required') ||
      this.tituloFormControl.hasError('maxlength') ||
      this.fechaTareaFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.tituloFormControl.markAsTouched();
      this.fechaTareaFormControl.markAsTouched();
      // this.horaTareaInput.horaFormControl.markAsTouched();
      // this.horaNotificacionInput.horaFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    // El servidor entiende la fecha hora como un campo único
    if (this.tarea.fechaTarea && this.tarea.horaTarea) {
      var momentFechaTarea = moment(this.tarea.fechaTarea);
      this.tarea.fechaTarea = momentFechaTarea.format("YYYY-MM-DD") + " " + this.tarea.horaTarea + ":00";
    }

    // El servidor entiende la fecha hora como un campo único
    if (this.tarea.fechaNotificacion && this.tarea.horaNotificacion) {
      var momentFechaNotificacion = moment(this.tarea.fechaNotificacion);
      this.tarea.fechaNotificacion = momentFechaNotificacion.format("YYYY-MM-DD") + " " + this.tarea.horaNotificacion + ":00";

      // La fecha-hora de la notificación debe ser menor a la fecha-hora de la tarea
      if (moment(this.tarea.fechaNotificacion).isSameOrAfter(moment(this.tarea.fechaTarea))) {
        throw "La fecha-hora de la notificación debe ser menor a la fecha-hora de la tarea";
      }

      if(!this.notificacion){
        this.tarea.fechaNotificacion = '';
        this.tarea.horaNotificacion = '';
      }

    }



    return this.tarea;
  }

  traerResposables() {
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }
      });
  }

  getGrupos(){
    this.usuarioService.getGrupos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
    ).subscribe(
      respuesta => {
        console.log("grupos", respuesta);
        let grupos = [];
        respuesta.data.forEach(element => {
          grupos.push({
            id: element.id,
            descripcion: element.descripcion,
            cantidad_usuarios: element.cantidad,
            usuarios: element.usuarios
          })
        });
        this.grupos = grupos;
      },

      (err) => {

      }
    );
  }
  
  getResponsables() : any[] {
    let listaResponsables = [];

    this.responsables.forEach(element => {
      listaResponsables.push({
        IdUsuario: element
      })
    });

    return listaResponsables;
  }

  getGrupoValue(grupo){
    return grupo.id + "_g";
  }

  testHora(){
    console.log(this.tarea.horaNotificacion);
    
  }

}
